import React, { FC } from "react";
import { Switch, Route, Redirect } from "react-router-dom"

import Home from "pages/Home";
import CheckTerms from "pages/check/Terms";
import CheckPrivacy from "pages/check/Privacy";
import CheckTokushoho from "pages/check/Tokushoho";
type Props = {}
const Router: FC<Props> = (props) => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/check/terms" component={CheckTerms} />
      <Route exact path="/check/privacy" component={CheckPrivacy} />
      <Route exact path="/check/tokushoho" component={CheckTokushoho} />
      {/* 廃止したパス（/dev, /aidev, /security, /unsubscribe, /privacy 等）はトップへ */}
      <Redirect to="/" />
    </Switch>
  )
}

export default Router;
